import { gql } from "@apollo/client";
import { BUSINESS_FIELDS_FRAGMENT } from "./business";

export const GET_RATINGS = gql`
  query GetRatings($bookingTypeId: Int!) {
    getRatings(bookingTypeId: $bookingTypeId) {
      id
      bookingTypeId
      bookingId
      review
      rating
      desc
    }
  }
`;

export const GET_INVITEE_QUESTIONS = gql`
  query GetInviteeQuestions($bookingTypeId: Int, $staffId: Int) {
    getInviteeQuestions(bookingTypeId: $bookingTypeId, staffId: $staffId) {
      id
      title
      type
      required
      bookingTypeId
    }
  }
`;
export const GET_INVITEE_ANSWERS = gql`
  query getInviteeAnswers($bookingTypeId: Int!) {
    getInviteeAnswers(bookingTypeId: $bookingTypeId) {
      id
      title
      questionId
    }
  }
`;
export const GET_BOOKING_ANSWERS = gql`
  query GetBookingAnswers($staffId: Int, $email: String) {
    getBookingAnswers(staffId: $staffId, email: $email) {
      id
      answer
      questionId
      bookingId
    }
  }
`;
export const GET_INTEGRATION = gql`
  query getIntegration($integration: String!) {
    getIntegration(integration: $integration) {
      id
      name
      logo
      description
      tags
    }
  }
`;
export const GET_INTEGRATIONS = gql`
  query getIntegrations {
    getIntegrations {
      id
      name
      logo
      description
      tags
    }
  }
`;
export const GET_USER_INTEGRATIONS = gql`
  query getUserIntegrations($staffId: Int!) {
    getUserIntegrations(staffId: $staffId) {
      integrationId
    }
  }
`;
export const GET_ALL_TAGS = gql`
  query {
    getAllTags
  }
`;

export const GET_TOKEN = gql`
  query GetToken($userId: Int, $staffId: Int, $subscriptionId: Int, $businessId: Int) {
    getToken(
      userId: $userId
      staffId: $staffId
      subscriptionId: $subscriptionId
      businessId: $businessId
    ) {
      token
    }
  }
`;


export const GET_BUSINESS_BY_CATEGORYID = gql`
query BusinessByCategory($categoryId: Int!, $cityId: Int, $countryId: Int) {
  businessByCategory(categoryId: $categoryId, cityId: $cityId, countryId: $countryId) {
    ${BUSINESS_FIELDS_FRAGMENT}
  }
}
`


export const SEARCH = gql`
query SearchBusinesses($query: String!) {
  search(query: $query) {
    ${BUSINESS_FIELDS_FRAGMENT}
  }
}
`

export const GET_ACTIVE_BUSINESS_CATEGORIES = gql`
query GetBookingTypesByActiveCities($countryId: Int!) {
  getBookingTypesByActiveCities(countryId: $countryId) {
    city
    cityId
    categories {
      id
      name
    }
  }
}
`

export const CHECK_LINK = gql`
 query CheckLink($link: String!, $bookingTypeId: Int) {
  checkBookingLink(link: $link, bookingTypeId: $bookingTypeId)
}
`;

export const GET_BUSINESS_PAYOUT = gql`
  query GetBusinessPayout($businessId: ID!) {
    getBusinessPayout(businessId: $businessId) {
      provider
      identifier 
    }
  }
`;

export const SAVE_BUSINESS_PAYOUT = gql`
  mutation SaveBusinessPayout(
    $businessId: ID!
    $provider: PayoutProvider!
    $identifier: String!
  ) {
    saveBusinessPayout(
      businessId: $businessId
      provider: $provider
      identifier: $identifier
    ) {
      id
      provider
      identifier
    }
  }
`;

export const ADD_PAYMENT = gql`
mutation AddPayment($businessId: ID!, $identifier: String!, $paymentMethodId: ID!) {
  addPayment(businessId: $businessId, identifier: $identifier, paymentMethodId: $paymentMethodId) {
    id
    identifier
  }
}
`

export const UPDATE_PAYMENT = gql`
mutation UpdatePayment($id: ID!, $identifier: String!) {
  updatePayment( id: $id, identifier: $identifier) {
    id
    identifier
  }
}
`

export const DELETE_PAYMENT = gql`
mutation DeletePayment($id: ID!) {
  deletePayment(id: $id) {
    message
  }
}
`

export const GET_PAYMENT_METHODS = gql`
 query PaymentMethods{ 
  paymentMethods { 
  id
  type  
  isActive
  }
}
`;

export const UPDATE_PAYMENT_METHOD = gql`
  mutation UpdatePaymentMethod($id: ID!, $isActive: Boolean!) {
    updatePaymentMethod(id: $id, isActive: $isActive) {
      id
      isActive
    }
  }
`;

export const DELETE_PAYMENT_METHOD = gql`
  mutation DeletePaymentMethod($id: ID!) {
    deletePaymentMethod(id: $id) {
      id
    }
  }
`;
export const GET_SEAT_USAGE = gql`
  query GetSeatUsage($businessId: ID!) {
    getSeatUsage(businessId: $businessId) {
      paidSeats
      usedSeats
      seatsLeft
    }
  }
`;

export const GET_PLANS = gql`
  query Plans {
    plans {
      id
      code
      name
      description
      features
      capabilities
      isActive
      pricing {
        baseMonthly
        perResidentMonthly
        perStaffMonthly
        perUnitMonthly
        quantityMetric
      }
    }
  }
`;

export const GET_PLANS_LEGACY = gql`
  query PlansLegacy {
    plans {
      id
      code
      name
      description
      features
      capabilities
      isActive
      pricing {
        baseMonthly
        perResidentMonthly
      }
    }
  }
`;

export const CREATE_STRIPE_SUBSCRIPTION = gql`
  mutation CreateStripeSubscription(
    $businessId: ID!
    $planId: ID!
    $residentCount: Int!
    $productKey: String
  ) {
    createStripeSubscription(
      businessId: $businessId
      planId: $planId
      residentCount: $residentCount
      productKey: $productKey
    ) {
      checkoutUrl
    }
  }
`;

export const CONFIRM_STRIPE_CHECKOUT_SESSION = gql`
  mutation ConfirmStripeCheckoutSession($sessionId: ID!) {
    confirmStripeCheckoutSession(sessionId: $sessionId) {
      id
      planId
      productKey
      status
      subscribedAt
      nextBillingAt
      residentSeats
      residentCount
    }
  }
`;

export const GET_BOOKING_PROVIDER_CONNECTION = gql`
  query GetBookingProviderConnection($businessId: ID!) {
    getBookingProviderConnection(businessId: $businessId) {
      id
      businessId
      providerType
      externalUrl
      providerBusinessId
      providerBusinessUrl
      providerResourceId
      status
      confirmationOwner
      enabled
      managementUrl
      publicBookingUrl
      capabilities {
        key
        label
        availabilityMode
        bookingMode
        changeMode
        automaticAvailability
        automaticBooking
        automaticUpdates
        supportsBookOnBehalf
        requiresOAuth
      }
      lastValidatedAt
      lastSyncedAt
      lastError
    }
  }
`;

export const SAVE_BOOKING_PROVIDER_CONNECTION = gql`
  mutation SaveBookingProviderConnection($input: SaveBookingProviderConnectionInput!) {
    saveBookingProviderConnection(input: $input) {
      id
      businessId
      providerType
      externalUrl
      providerBusinessId
      providerBusinessUrl
      providerResourceId
      status
      confirmationOwner
      enabled
      managementUrl
      publicBookingUrl
      capabilities {
        key
        label
        availabilityMode
        bookingMode
        changeMode
        automaticAvailability
        automaticBooking
        automaticUpdates
        supportsBookOnBehalf
        requiresOAuth
      }
      lastValidatedAt
      lastSyncedAt
      lastError
    }
  }
`;

export const VALIDATE_BOOKING_PROVIDER_CONNECTION = gql`
  mutation ValidateBookingProviderConnection($businessId: ID!) {
    validateBookingProviderConnection(businessId: $businessId) {
      id
      businessId
      providerType
      externalUrl
      providerBusinessId
      providerBusinessUrl
      providerResourceId
      status
      confirmationOwner
      enabled
      managementUrl
      publicBookingUrl
      capabilities {
        key
        label
        availabilityMode
        bookingMode
        changeMode
        automaticAvailability
        automaticBooking
        automaticUpdates
        supportsBookOnBehalf
        requiresOAuth
      }
      lastValidatedAt
      lastSyncedAt
      lastError
    }
  }
`;

export const GET_BOOKING_PROVIDER_OPTIONS = gql`
  query BookingProviderOptions {
    bookingProviderOptions {
      key
      label
      availabilityMode
      bookingMode
      changeMode
      automaticAvailability
      automaticBooking
      automaticUpdates
      supportsBookOnBehalf
      requiresOAuth
    }
  }
`;

export const CREATE_BOOKING_THROUGH_PROVIDER = gql`
  mutation CreateBookingThroughProvider($input: CreateBookingThroughProviderInput!) {
    createBookingThroughProvider(input: $input) {
      ok
      status
      providerType
      bookingId
      message
      handoffUrl
    }
  }
`;

export const UPDATE_STRIPE_SEATS = gql`
  mutation UpdateStripeSeats($businessId: ID!, $seats: Int!, $productKey: String) {
    updateStripeSeats(businessId: $businessId, seats: $seats, productKey: $productKey)
  }
`;

export const CANCEL_STRIPE_SUBSCRIPTION = gql`
  mutation CancelStripeSubscription($businessId: ID!) {
    cancelStripeSubscription(businessId: $businessId) {
      success
      effectiveDate
    }
  }
`;

export const GET_BILLING_SUBSCRIPTION = gql`
  query GetBillingSubscription($businessId: ID!, $productKey: String) {
  getBillingSubscription(businessId: $businessId, productKey: $productKey) {
    id
    planId
    productKey
    status
    provider
    subscribedAt
    nextBillingAt
    canceledAt
    residentSeats     # PAID seats
    residentCount     # USED seats
  }
}
`;

export const GET_BILLING_SUBSCRIPTION_LEGACY = gql`
  query GetBillingSubscriptionLegacy($businessId: ID!) {
    getBillingSubscription(businessId: $businessId) {
      id
      planId
      status
      provider
      subscribedAt
      nextBillingAt
      canceledAt
      residentSeats
      residentCount
    }
  }
`;

export const CREATE_STRIPE_SUBSCRIPTION_LEGACY = gql`
  mutation CreateStripeSubscriptionLegacy(
    $businessId: ID!
    $planId: ID!
    $residentCount: Int!
  ) {
    createStripeSubscription(
      businessId: $businessId
      planId: $planId
      residentCount: $residentCount
    ) {
      checkoutUrl
    }
  }
`;

export const CHECK_SUBSCRIPTION = gql`
  query Query($subscriptionId: String!) {
  checkSubscription(externalSubscriptionId: $subscriptionId)
}
`;

export const GET_GOOGLE_CALENDAR_EVENTS = gql`
  query GetGoogleCalendarEvents($staffId: Int!, $currentMonth: String!) {
  getGoogleCalendarEvents(staffId: $staffId, currentMonth: $currentMonth) {
    success
      events {
      id
      bookingTypeId
      timezone
      bookingId
      time
      createdAt
      status
      inviteeName
      inviteeEmail
      bookingTypeName
      staffName
      staffId
      duration
      isAllDay
      source
      htmlLink
      hangoutLink
    }
  }
}
`;

export const CHECK_GOOGLE_CALENDAR_INTEGRATION = gql`
  query Query($staffId: Int!) {
  checkGoogleCalendarIntegration(staffId: $staffId)
}
`;


export const GET_CALENDAR_CATEGORIES = gql`
  query GetCalendarCategories {
    getCalendarCategories {
    id
    name
      calendars {
      id
      name
      type
    }
  }
}
`;

export const GET_CALENDARS_BY_CATEGORY = gql`
  query GetCalendarsByCategory($categoryId: ID!) {
  getCalendarsByCategory(categoryId: $categoryId) {
    id
    name
    type
  }
}
`;

export const ADD_CUSTOM_CALENDAR = gql`
  mutation AddCustomCalendar($input: AddCustomCalendarInput!) {
  addCustomCalendar(input: $input) {
    id
    name
  }
}
`;

export const REMOVE_CUSTOM_CALENDAR = gql`
  mutation RemoveCustomCalendar($id: ID!) {
  removeCustomCalendar(id: $id) {
    message
  }
}
`;
